/* 🤖 this file was generated by script */
export const wsolidiconLightbulb03 = {
  name: 'lightbulb_03',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.5 22a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1M4 9a8 8 0 1 1 12 6.93v.1q0 .66-.02 1.13-.02.5-.2.99a3 3 0 0 1-1.63 1.62q-.5.2-.99.2-.47.04-1.13.03h-.06q-.66 0-1.13-.02a3 3 0 0 1-.99-.2 3 3 0 0 1-1.62-1.63 3 3 0 0 1-.2-.99q-.04-.47-.03-1.13v-.1A8 8 0 0 1 4 9" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
